import * as Sentry from '@sentry/react';

import { escapeRegExp } from '@utils/filters/escapeRegExp';

if (import.meta.env.VITE_SENTRY_DSN)
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    tracePropagationTargets: [
      new RegExp(escapeRegExp(import.meta.env.VITE_GRAPHQL_API_URL)),
    ],
    integrations: [
      Sentry.browserTracingIntegration({}),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
